import React, { useEffect, useState } from 'react'
import { Accordion, AccordionDetails, AccordionSummary } from 'components/Shared/Accordion'
import styles
  from 'components/Order/OrderDetails/OrderTransactionsList/OrderTransactionListItem/OrderTransactionListItem.module.css'
import { ReadOnlyTextField } from 'components/Shared/ReadOnlyTextField'
import { useTranslation } from 'react-i18next'
import { FieldsRow } from 'components/Order/OrderDetails/OrderPointsList/FieldsRow'
import { fetchContractor } from 'services/ContractorService'
import { HTTP_404_ERROR } from 'Constants'
import { useErrorHandling } from 'context/errorHandling'
import { LinearLoader } from 'components/Shared/LinearLoader'
import { ORDER_TRANSACTION_PAYMENT_DATE_READ, useAuth } from '../../../../../context/auth'

export function OrderTransactionListItem ({ transaction, transactionServiceTypes, title, number }) {
  const { t } = useTranslation()
  const { handleError } = useErrorHandling()
  const { hasAnyPrivileges } = useAuth()

  const [contractor, setContractor] = useState(null)

  useEffect(() => {
      if (transaction.contractorId) {
        fetchContractor(transaction.contractorId)
          .then(setContractor)
          .catch(error => handleError(error, {
            [HTTP_404_ERROR]: 'notifications.error.contractorNotFound'
          }))
      } else setContractor(null)
    }, [transaction, handleError]
  )

  return (
    <div className={styles.root}>
      <Accordion isExpandedOnStart>
        <AccordionSummary>
          <div className={styles.titleContainer}>
            <div className={styles.numberBox}>{number}</div>
            <div className={styles.titleBox}>{t(title)}</div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className={styles.body}>
            <ReadOnlyTextField
              label={t(`form.order.transaction.${transaction.transactionType}.contractor`)}
              value={contractor?.fullName}
            />
            {transactionServiceTypes ? <ReadOnlyTextField
              label={`form.order.transaction.${transaction.transactionType}.type`}
              value={transactionServiceTypes?.find(serviceType => serviceType.id === transaction.serviceTypeId)?.name}
            /> : <LinearLoader/>}
            <FieldsRow>
              <ReadOnlyTextField
                label="form.order.transaction.price.amount"
                value={transaction.price.amount}
              />
              <ReadOnlyTextField
                label="form.order.transaction.price.currencyCode"
                value={transaction.price.currencyCode}
              />
            </FieldsRow>
            {hasAnyPrivileges([ORDER_TRANSACTION_PAYMENT_DATE_READ]) && <ReadOnlyTextField
              label={'form.order.transaction.paymentDays'}
              value={transaction.paymentDays + ' '+ t('form.order.transaction.days')}
            />}
            <ReadOnlyTextField
              label={'form.order.transaction.comment'}
              value={transaction.comment}
            />
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
